// Interfaces
import { IRouteParent } from 'routes/route.interface'

// Content Management Route List
import { contentHomepageRoutes } from './content-homepage.router'
import { contentAboutUsRoutes } from './content-about-us.router'
import { contentCertificationRoutes } from './content-certification.router'
import { contentTukRoutes } from './content-tuk.router'
import { contentGalleryRoutes } from './content-gallery.router'
import { contentContactUsRoutes } from './content-contact-us.router'

// Constant
import { CONTENT_URL, CONTENT_MODULE } from 'constant/url.constant'
import { ACCESS_CODE_CONTENT_MANAGEMENT } from 'constant/access.constant'

const contentRoutes: IRouteParent = {
  path: CONTENT_URL.HOMEPAGE,
  meta: {
    attrs: {
      module: CONTENT_MODULE,
      icon: 'back-office/icon-content',
      label: 'backOffice.contentManagement',
      accessCodes: ACCESS_CODE_CONTENT_MANAGEMENT,
    },
  },
  children: [
    ...contentHomepageRoutes,
    ...contentAboutUsRoutes,
    ...contentCertificationRoutes,
    ...contentTukRoutes,
    ...contentGalleryRoutes,
    ...contentContactUsRoutes,
  ],
}

export { contentRoutes }
